import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useEffect, useRef, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";

export default function VendorLedger() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const [filterBalanceOnly, setFilterBalanceOnly] = useState(false);
  const [filterGstOnly, setFilterGstOnly] = useState(false);

  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    VendorLedgerData: [],
    searchQuery: "",
  });

  useEffect(() => {
    GetCustomerLedgerList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize]);

  const GetCustomerLedgerList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_vendor + "?" + MainFilterHandler(pageStates);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerLedgerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const formatAmountLocal = (val) => {
          return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0
          }).format(val);
        };

        const newData = response?.data?.vendor?.map((item) => {
          const mockPOVolume = 1200000 + (item?.id % 7) * 150000;
          const mockPaid = 800000 + (item?.id % 5) * 100000;
          const mockOutstanding = Math.max(0, mockPOVolume - mockPaid);
          const mockTerms = (item?.id % 3 === 0) ? "Net 30" : ((item?.id % 3 === 1) ? "Net 45" : "Immediate");
          const mockTDS = (item?.id % 2 === 0) ? "1%" : "2%";

          return {
            ...item,
            siteStatus: item?.status,
            poVolumeVal: mockPOVolume,
            outstandingDueVal: mockOutstanding,
            poVolume: formatAmountLocal(mockPOVolume),
            outstandingDue: formatAmountLocal(mockOutstanding),
            paymentTerms: mockTerms,
            tdsRate: mockTDS,
            firmName: item?.firmName || "N/A"
          };
        });
        setPageStates((prevStates) => ({
          ...prevStates,
          VendorLedgerData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.vendor_ledger_detail + `/${data?.id}`, { state: data });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Vendor Name" },
    { value: "gstNumber", label: "GSTIN" },
    { value: "firmName", label: "Firm Name" },
    { value: "poVolume", label: "Total PO Volume" },
    { value: "outstandingDue", label: "Outstanding Due" },
    { value: "paymentTerms", label: "Payment Terms" },
    { value: "tdsRate", label: "TDS Slab" },
    { value: "siteStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "edit",
      clickHandler: HandleView,
    }
  ];

  // Dynamic filter lists
  const displayData = Array.isArray(pageStates?.VendorLedgerData)
    ? pageStates.VendorLedgerData.filter(item => {
        if (filterBalanceOnly) {
          if ((item?.outstandingDueVal || 0) <= 0) return false;
        }
        if (filterGstOnly) {
          if (!item?.gstNumber || item?.gstNumber === "" || item?.gstNumber === "N/A") return false;
        }
        return true;
      })
    : [];

  const totalOutstandingAP = Array.isArray(pageStates?.VendorLedgerData)
    ? pageStates.VendorLedgerData.reduce((acc, curr) => acc + (curr.outstandingDueVal || 0), 0)
    : 0;

  const totalPOVolume = Array.isArray(pageStates?.VendorLedgerData)
    ? pageStates.VendorLedgerData.reduce((acc, curr) => acc + (curr.poVolumeVal || 0), 0)
    : 0;

  const formatAmountLocal = (val) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0
    }).format(val);
  };

  return (
    <>
      <div className="content container-fluid">
        <MainHeading
          title={"Vendor Accounts Directory"}
        />

     

        {/* Vendor Table Card */}
        <div className="card mb-4 shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
          <div className="card-body p-4">
            {/* Header controls & filter toggles */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <FilterComponent
                handleSearch={handleSearchChange}
              />
             
            </div>

            <CommonTable
              TableHeading={TableHeading}
              TableData={displayData}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={filterBalanceOnly || filterGstOnly ? displayData.length : pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates?.pageSize}
            />
          </div>
        </div>
      </div>
    </>
  );
}
